import { useState, FC } from "react";
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from "react-i18next";
import CureFormByStoreGrid from "./CureFormByStoreGrid";
import CureFormByStoreGridPluginSettings from "./CureFormByStoreGridPluginSettings";
import { IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common";
import { GridSelectorModalWindow } from "../../../../components/modalWindows/GridSelectorModalWindow";

const CureFormByStoreSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntity ?? []);
    const gridId = uuidv4();
    const plugin = CureFormByStoreGridPluginSettings
    const { t } = useTranslation();
    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            gridDisplayName={plugin?.name ?? t('directory.CureForm.title')}
            ok={{
                onClick: () => props.multipleSelect ? props.ok(entities) : props.ok?.(entity),
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin
                    ? <CureFormByStoreGrid
                        data={entities}
                        gridId={gridId}
                        plugin={plugin}
                        baseGridFilter={props.gridFilter}
                        multipleSelect={props.multipleSelect}
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal as string, displayName: row.cureFormName as string })}
                        onMultipleSelect={(rows) => {
                            rows && setEntities(rows.map(x => ({ idGlobal: x.idGlobal as string, displayName: x.cureFormName } as IEntitySimpleDTO)))
                        }}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal as string, displayName: row.cureFormName as string })
                            props.ok?.(entity)
                        }}
                    />
                    : <p>{t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default CureFormByStoreSelectorModal